<mat-nav-list>
  <mat-list-item [disableRipple]="browserControlCommunicationService.disableRippleEffect" *ngFor="let lead of responseLeads | orderBy: '-lastOutcomeSentDate'"
    (click)="openLead(lead)"> {{lead.description}}
  </mat-list-item>
</mat-nav-list>